import { Breadcrumbs, Link as MuiLink, Tooltip } from "@mui/material";
import type { FC } from "react";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { type TreeViewItem } from "../utils";

export const FolderBreadcrumb: FC<{
  breadcrumbs: TreeViewItem[];
  onFolderSelect: (folderId: string) => void;
}> = ({ breadcrumbs, onFolderSelect }) => {
  return (
    <Breadcrumbs separator="/">
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbLink
          key={breadcrumb.id}
          breadcrumb={breadcrumb}
          isFirst={index === 0}
          onFolderSelect={onFolderSelect}
        />
      ))}
    </Breadcrumbs>
  );
};

const BreadcrumbLink: FC<{
  breadcrumb: TreeViewItem;
  isFirst: boolean;
  onFolderSelect: (folderId: string) => void;
}> = ({ breadcrumb, isFirst, onFolderSelect }) => {
  const shouldTruncate = breadcrumb.label.length > 16;

  return (
    <ConditionalWrapper
      condition={shouldTruncate}
      wrapper={(children) => (
        <Tooltip title={breadcrumb.label} enterDelay={500} placement="top">
          {children}
        </Tooltip>
      )}
    >
      <MuiLink
        component="button"
        underline="none"
        onClick={() => onFolderSelect(breadcrumb.id)}
        sx={{
          cursor: "pointer",
          ...(shouldTruncate && {
            maxWidth: 200,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }),
        }}
        {...(isFirst ? { color: "primary.main" } : { color: "inherit" })}
      >
        {breadcrumb.label}
      </MuiLink>
    </ConditionalWrapper>
  );
};
